import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { OnboardingProvider } from "./OnboardingContext";
import { OnboardingStepActionsProvider } from "./OnboardingStepActions";
import OnboardingTrain from "./OnboardingTrain";
import StepSuccess from "./steps/StepSuccess";

export default function OnboardingRoutes() {
  return (
    <OnboardingProvider>
      <OnboardingStepActionsProvider>
        <Routes>
          <Route path="/onboarding" element={<Navigate to="/onboarding/photos" replace />} />
          <Route path="/onboarding/success" element={<StepSuccess />} />
          <Route path="/onboarding/*" element={<OnboardingTrain />} />
        </Routes>
      </OnboardingStepActionsProvider>
    </OnboardingProvider>
  );
}
